import service from "../../request/request"
export function get_car_list(vin) {
    return service({
        url: "/api/car/get_car_options_list",
        method: 'POST',
        data: {
            row: {
                vin:vin,
            }
        }
    
    })
}
//获取车辆基本信息
export function get_car_base_info(vin) {
    return service({
        url: "/api/car/get_car_base_info",
        method: 'POST',
        data: {
            row: {
                vin:vin,
            }
        }
    })
}
//获取车辆动态数据
export function get_car_dynamic_data(vin) {
    return service({
        url: "/api/car/get_car_data",
        method: 'POST',
        data: {
            row: {
                vin:vin,
            }
        }
    })
}
//获取地图路线
export function get_map_line(vin) {
    return service({
        url: "/api/car/get_map_line",
        method: 'POST',
        data: {
            row: {
                vin:vin,
            }
        }
    })
}
//获取gps
export function get_car_real_time_gps(vin) {
    return service({
        url: "/api/car/get_car_real_time_gps",
        method: 'POST',
        data: {
            row: {
                vin:vin,
            }
        }
    })
}

//视频流
export function get_car_video_flow(vin) {
    return service({
        url: "/api/car/get_car_video_flow",
        method: 'POST',
        data: {
            row: {
                vin:vin,
            }
        }
    })
}
